import http from '../../helpers/http';
import {ValidatorError} from '../../hooks/templateHooks/useServerErrorValidation'

export const Login = async(AjaxObj) =>{
    
    const {data} = await http.post(`/JolteonAccess/User/Login`,{userName:AjaxObj.UserName,password:AjaxObj.Password}).catch(error=>ValidatorError(error));
    return data ;
}

export const Logout = async({idUser, refreshToken}) =>{   
    const {data} = await http.post(`/JolteonAccess/User/Logout`,{idUser,refreshToken}).catch(error=>ValidatorError(error));
    return data ;
}

export const Session = async({idUser, refreshToken}) =>{  
    const {data} = await http.post(`/JolteonAccess/User/Session`,{idUser,refreshToken}).catch(error=>ValidatorError(error));
    return data ;
}